<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="6" lg="4">
                    <ValidationProvider name="payment_date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('payment_date')">
                            <select-date v-model="form.payment_date" :is-time="false" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <ValidationProvider name="amount" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('amount')">
                            <b-form-input
                                type="number"
                                min="0" step=".01"
                                v-check-min-max-value
                                v-model="form.amount"
                            ></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <ValidationProvider name="invoice_number" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('invoice_number')">
                            <b-form-input v-model="form.invoice_number"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="file" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('file')">
                            <div class="d-flex custom-file-upload">
                                <b-form-file v-model="form.file"
                                             :state="errors[0] ? false : (valid ? true : null)"
                                             :placeholder="$t('select_file')"
                                             :drop-placeholder="$t('drop_file')"
                                             ref="fileInput"
                                />
                                <b-button variant="outline-secondary"
                                          @click="$refs.fileInput.$el.childNodes[0].click();">{{ $t('browse') }}
                                </b-button>
                            </div>
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
        </ValidationObserver>

        <div class="col-6 mt-3 d-flex">
            <b-button
                @click="storeForm"
                type="button"
                :disabled="formLoading"
                variant="primary"
                class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </div>
    </div>
</template>

<script>
    //Component

    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"

    //Service
    import PilotagePaymentDetailService from "@/services/PilotagePaymentDetailService";

    export default {
        components: {
            ValidationProvider,
            ValidationObserver,
        },
        props: {
            formId: {
                type: Number,
            }
        },
        data() {
            return {
                formLoading: false,
                form: {
                    pilotage_payment_id: null,
                    payment_date: null,
                    amount: null,
                    invoice_number: null,
                    file: null,
                },
            }
        },
        methods: {
            async storeForm() {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid && this.formId && this.checkPermission('pilotagepaymentdetail_store')) {
                    this.formLoading = true;

                    let formData = new FormData();
                    formData.append('pilotage_payment_id', this.formId)
                    formData.append('payment_date', this.form.payment_date)
                    formData.append('amount', this.form.amount)
                    formData.append('invoice_number', this.form.invoice_number)

                    if(this.form.file) {
                        formData.append('file', this.form.file)
                    }

                    PilotagePaymentDetailService.store(formData)
                                   .then((response) => {
                                       this.formLoading=false;
                                       this.$toast.success(this.$t("api." + response.data.message));
                                       this.$emit("addPaymentFormSuccess")
                                   })
                                   .catch((error) => {
                                       this.showErrors(error, this.$refs.formModalValidate)
                                   })
                }
            },
        }
    }
</script>
